import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { useState } from "react";

export const useIsReplitOnboardingModalEligible = () => {
  const { onboardingFlags, currentCommunity, currentCommunityMember } =
    usePunditUserContext();
  const isReplitSufOnboardingEnabled = Boolean(
    onboardingFlags?.suf_onboarding_replit,
  );
  const isOwner =
    currentCommunityMember?.id === currentCommunity?.owner_community_member_id;

  const isEligible =
    isReplitSufOnboardingEnabled &&
    isOwner &&
    !currentCommunity?.replit_onboarding_questions_answered;

  const [wasEligible, setWasEligible] = useState(isEligible);
  if (isEligible && !wasEligible) {
    setWasEligible(true);
  }

  return wasEligible;
};
